<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 md6 lg6>
          <h1 class="headline">{{ $t('suppliers.title') }}</h1>
        </v-flex>

        <v-flex xs12 sm6 md6 lg6>
          <v-layout wrap align-center justify-end>
            <v-btn
              v-if="$can('supplier_add')"
              color="warning mt-2"
              large
              depressed
              @click="
                () => {
                  dialog.opened = true;
                  dialog.id = null;
                  dialog.currentValue = '';
                }
              "
            >
              {{ $t('suppliers.add') }}
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-layout wrap align-center class="search-wrapper mt-3">
      <div class="d-flex search">
        <v-text-field
          v-model="searchString"
          ref="search"
          autocomplete="off"
          solo
          :placeholder="$t('roles.search')"
        />
        <v-btn
          type="button"
          class="search-btn warning"
          depressed
          large
          @click="filters.name = searchString"
        >
          {{ $t('common.btns.search') }}
        </v-btn>
      </div>
    </v-layout>

    <v-flex xs12>
      <v-data-table
        ref="suppliers-table"
        hide-default-footer
        :headers="headers"
        :items="list"
        :height="tableHeight"
        :loading="loading"
      >
        <template #item="{ item }">
          <tr>
            <td v-if="$can('supplier_edit')" width="50">
              <v-btn
                color="warning"
                icon
                @click="
                  () => {
                    dialog.id = item.id;
                    dialog.currentValue = item.name;
                    dialog.opened = true;
                  }
                "
              >
                <v-icon>mdi-pencil-circle-outline</v-icon>
              </v-btn>
            </td>
            <td>{{ item.num }}</td>
            <td>{{ item.name }}</td>
          </tr>
        </template>

        <template #footer>
          <v-divider />
          <div class="pt-1 pb-2">
            <v-pagination
              color="warning"
              :value="currentPage"
              :length="lastPage"
              dark
              circle
              @input="fetchList({ ...filters, page: $event })"
            />
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <v-snackbar v-model="snack.opened" :color="snack.color" bottom right>
      {{ snack.message }}
    </v-snackbar>

    <text-field-edit-dialog
      v-model="dialog.opened"
      param-name="name"
      :label="dialog.id ? $t('common.btns.edit') : $t('suppliers.add')"
      :current-value="dialog.currentValue"
      required
      @save="dialog.id ? updateItem($event) : addNew($event)"
    />
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
import TextFieldEditDialog from '@/components/shared/TextFieldEditDialog.vue';
import calcTableHeight from '@/helpers/calcTableHeight';

export default {
  components: { TextFieldEditDialog },
  data: () => ({
    loading: false,
    tableHeight: 'auto',
    searchString: '',
    filters: {
      name: '',
    },
    dialog: {
      opened: false,
      id: null,
      currentValue: '',
    },
    snack: {
      opened: false,
      message: '',
      color: '',
    },
  }),
  watch: {
    filters: {
      immediate: true,
      deep: true,
      handler(params) {
        this.fetchList(params);
      },
    },
  },
  computed: {
    ...mapState({
      list: ({ suppliers }) => suppliers.list,
      currentPage: ({ suppliers }) => suppliers.currentPage,
      lastPage: ({ suppliers }) => suppliers.lastPage,
      perPage: ({ suppliers }) => suppliers.perPage,
    }),
    headers() {
      const items = [
        { text: this.$t('common.number'), sortable: false },
        { text: this.$t('companiesList.tableHeaders.name'), sortable: false },
      ];

      if (this.$can('supplier_edit')) {
        items.unshift({ sortable: false });
      }

      return items;
    },
  },
  methods: {
    async fetchList(params) {
      this.loading = true;
      await this.$store.dispatch('suppliers/fetchList', params);
      this.loading = false;
    },
    async proccessResult({ success }) {
      const snack = {
        opened: true,
        message: this.$t('common.saved'),
        color: 'success',
      };

      if (success) {
        await this.fetchList();
      } else {
        snack.message = this.$t('common.errors.APIerror');
        snack.color = 'error';
      }

      this.snack = snack;
    },
    async addNew(params) {
      const result = await this.$store.dispatch('suppliers/addNew', params);
      this.proccessResult(result);
    },
    async updateItem(params) {
      const result = await this.$store.dispatch('suppliers/updateItem', {
        id: this.dialog.id,
        params,
      });
      this.proccessResult(result);
    },
  },
  mounted() {
    const table = this.$refs['suppliers-table'];
    this.tableHeight = calcTableHeight(table.$el);
  },
};
</script>

<style>
.search {
  max-width: 450px;
  width: 100%;
}

.v-pagination__item,
.v-pagination__navigation {
  box-shadow: none;
}
</style>
